<template>
    <div style="padding-left: 25px; padding-right: 25px; margin-top: -10px;">

        <v-row style="background-color: #fff; padding: 30px 30px 0px 30px; margin: 0!important;">
            <v-col cols="2">
                <v-icon large icon="mdi-arrow-left" @click="$router.push('/config')"
                    style="font-size: 46px">mdi-arrow-left</v-icon>
            </v-col>
            <v-col cols="8" style="text-align: center!important; margin-bottom: 20px;">
                <v-typography style="text-transform: uppercase; letter-spacing: 5px;">
                    Structure
                </v-typography>
            </v-col>
            <v-divider></v-divider>
        </v-row>
        <div style="width: 100%; text-align: center;" v-if="isLoadingStructure">
                    <v-progress-circular color="primary" indeterminate></v-progress-circular>
                    <h6>Loading data...</h6>
        </div>
        <div v-for="item in items" :key="item" class="mt-5">
            <div v-for="factory in item.factories" :key="factory">
                <v-tabs v-model="tab" align-tabs="center" color="" style="background-color: #fff; margin-bottom: 20px">
                    <v-tab :value="building.id" v-for="building in factory.buildings" :key="building">
                        <v-list-item :title="building.name" :subtitle="factory.name"></v-list-item>
                    </v-tab>
                </v-tabs>
                <v-tabs-window v-model="tab">
                    <v-tabs-window-item v-for="building in factory.buildings" :key="building" :value="building.id">
                        <v-btn @click="openCustomPcModal(building)">Add Custom Process</v-btn>
                        <v-card v-for="pc in building.process_cells" :key="pc"
                            style="padding: 20px; margin-bottom: 20px;">
                            <v-list-item :title="pc.name" :subtitle="pc.fbs_id"></v-list-item>
                            <v-btn outlined color="#000" @click="selectedProcessGroup = process_cell"
                                style="margin-right: 20px;">
                                <v-icon start>mdi-plus</v-icon>
                                Add new line
                                <v-dialog activator="parent" persistent>
                                    <template v-slot:default="{ isActive }">
                                        <v-card class="mx-auto" flat min-width="560" style="padding: 45px!important;"
                                            title="Enter the name of line">
                                            <v-card-text class="mb-5 text-center">
                                                <v-text-field variant="outlined" label="New Line"
                                                    v-model="newProcessName"></v-text-field>
                                                <v-select label="Select product" variant="outlined"
                                                    :items="productItemList" item-title="name" item-value="id"
                                                    v-model="selectedProduct"></v-select>
                                                <v-btn v-bind="props" outlined color="#000" block>
                                                    <v-icon start>mdi-plus</v-icon>
                                                    Create new product
                                                    <v-dialog activator="parent" persistent>
                                                        <template v-slot:default="{ isActive }">
                                                            <v-card class="mx-auto" flat min-width="560"
                                                                style="padding: 45px!important;"
                                                                title="Enter the name of line">
                                                                <v-card-text class="mb-5 text-center">
                                                                    <v-text-field variant="outlined"
                                                                        label="New product name"
                                                                        v-model="newProductName"></v-text-field>
                                                                    <v-text-field variant="outlined"
                                                                        label="Product d-number"
                                                                        v-model="productDnumber"></v-text-field>
                                                                </v-card-text>
                                                                <template v-slot:actions>
                                                                    <div class="">
                                                                        <v-btn variant="elevated" color="#3c6d72"
                                                                            style="width: 220px; margin-right: 10px;"
                                                                            @click="createNewProduct(newProductName, productDnumber, isActive)">
                                                                            Submit
                                                                        </v-btn>
                                                                        <v-btn @click="isActive.value = false;"
                                                                            variant="tonal"
                                                                            style="width: 220px; margin-left: 10px;">
                                                                            Cancel
                                                                        </v-btn>
                                                                    </div>
                                                                </template>
                                                            </v-card>
                                                        </template>
                                                    </v-dialog>
                                                </v-btn>
                                            </v-card-text>
                                            <template v-slot:actions>
                                                <div class="">
                                                    <v-btn variant="elevated" color="#3c6d72"
                                                        style="width: 220px; margin-right: 10px;"
                                                        @click="addLine(newProcessName, selectedProduct, pc, isActive)">
                                                        Submit
                                                    </v-btn>
                                                    <v-btn @click="isActive.value = false; newProcessName = '';"
                                                        variant="tonal" style="width: 220px; margin-left: 10px;">
                                                        Cancel
                                                    </v-btn>
                                                </div>
                                            </template>
                                        </v-card>
                                    </template>
                                </v-dialog>
                            </v-btn>
                            <v-btn color="primary" variant="outlined" class="mt-4 mb-4">
                                <v-icon start>mdi-plus</v-icon>
                                Add custom fields
                                <v-dialog activator="parent" persistent>
                                    <template v-slot:default="{ isActive }">
                                        <v-card class="mx-auto" style="" min-width="900">
                                            <v-toolbar>
                                                <v-btn icon="mdi-close" @click="isActive.value = false"></v-btn>
                                                <v-toolbar-title>Custom field
                                                    for
                                                    process cell {{ pc.name }}
                                                </v-toolbar-title>
                                            </v-toolbar>
                                            <v-card-text>
                                                <v-text-field variant="outlined" label="Field name"
                                                    v-model="customFieldName"></v-text-field>
                                                <v-select variant="outlined" label="Field type" :items="fieldTypes"
                                                    item-title="name" item-value="value" v-model="type"></v-select>
                                                <v-checkbox label="Active custom field"
                                                    v-model="activeCustomField"></v-checkbox>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn class="ms-2" @click="cancelStepper(isActive)"
                                                    prepend-icon="mdi-close" color="#1e2ec6"
                                                    variant="outlined">CANCEL</v-btn>
                                                <v-btn
                                                    @click="createCustomField(customFieldName, type, activeCustomField, pc.id, isActive)"
                                                    prepend-icon="mdi-content-save" color="#1e2ec6" variant="tonal">Save
                                                    custom field</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </template>
                                </v-dialog>
                            </v-btn>
                            <v-data-table :items="pc.lines" :search="search">
                                <template v-slot:item="{ item }">
                                    <tr style="padding-bottom: 25px!important;">
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.product.name }}</td>
                                        <td>
                                            <span v-for="machina in item.machines" :key="machina">
                                                <v-chip color="primary">
                                                    {{ machina.name }}
                                                </v-chip>
                                            </span>
                                        </td>
                                        <td>{{ item.process_cell.name }}</td>
                                        <td>
                                            <span v-for="mcf in item.combined_custom_fields" :key="mcf">
                                                <v-chip color="primary">
                                                    {{ mcf.name }}
                                                    <v-icon @click="openCustomFieldOptionsModal(mcf)">mdi-cog</v-icon>
                                                    <v-icon @click="openCustomFieldRemovalModal(mcf)">mdi-trash-can</v-icon>
                                                </v-chip>
                                            </span>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-tabs-window-item>
                </v-tabs-window>
            </div>
        </div>
        <v-snackbar v-model="snackbar" :timeout="timeout" color="success">
                            <div style="width: 100%!important; text-align: center!important;">{{ text }}</div>
                        </v-snackbar>
        <v-dialog v-model="showAddCustomFieldModal" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Add Custom Field</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="newCustomFieldName" placeholder="Custom Field Name"></v-text-field>
                    <v-autocomplete
                        v-model="selectedCustomFieldType"
                        :items="['string', 'int', 'float', 'bool', 'datetime', 'percentage', 'choices']"
                        label="Type"
                    ></v-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green" @click="addCustomField">Add</v-btn>
                    <v-btn color="red" @click="showAddCustomFieldModal = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showCustomFieldOptionsModal" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit/Configure Selected Custom field [{{ selectedCustomField.id }}]</span>
                </v-card-title>
                <v-card-text>
                    <v-divider></v-divider>
                    <div class="custom-field-options-row-container">
                        <span>Edit name: </span>
                        <input
                            v-model="selectedCustomField.name"
                            type="text"
                            style="border: 1px black solid; background-color: lightgray; margin-left: 10px"
                        />
                    </div>

                    <v-divider></v-divider>
                    <div class="custom-field-options-row-container">
                        <span>Edit type: </span>
                        <v-select
                            v-model="selectedCustomField.data_type"
                            dense
                            :items="['string', 'int', 'float', 'bool', 'choices', 'datetime']"
                        ></v-select>
                    </div>

                    <v-divider></v-divider>

                    <div v-if="selectedCustomField.data_type === 'choices'" class="custom-field-options-container">
                        <span>Edit Options</span>
                        <v-chip
                            v-for="choice in selectedCustomField.options"
                            :key="choice.id"
                            :class="{ 'custom-field': true, 'custom-field-loading': choice.loading }"
                        >
                            <p>{{ choice.value }}</p>
                            <v-progress-circular v-if="choice.loading" indeterminate color="primary"></v-progress-circular>
                            <v-icon v-else>mdi-delete</v-icon>
                        </v-chip>
                        <v-divider>
                            <v-chip class="custom-field">
                                <input
                                    v-model="newCustomFieldTypeOption"
                                    type="text"
                                    style="border: 1px black solid; background-color: lightgray; margin-left: 10px"
                                />
                                <v-icon @click="addCustomFieldTypeOption()" left>mdi-plus</v-icon> Add a choice
                            </v-chip>
                        </v-divider>
                    </div>

                    <v-divider></v-divider>
                    <span>Edit Validations</span>* TODO
                </v-card-text>
                <v-card-actions>
                    <v-btn color="lightgreen" @click="closeCustomFieldModal(true)">Save</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="lightgray" @click="closeCustomFieldModal(false)">Discard</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showCustomFieldRemovalModal" max-width="600px">
            <v-card>
                <v-card-title>Are You sure?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green" @click="removeCustomField">ok</v-btn>
                    <v-btn color="red" @click="showCustomFieldRemovalModal = false">nok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showAddCustomProcessModal" max-width="600px">
            <v-card>
                <v-card-title>Add Custom Process Cell</v-card-title>
                <v-card-subtitle>for {{this.selectedPcellBuilding.name}}</v-card-subtitle>
                <v-card-text>
                    <v-text-field v-model="newPcellName" placeholder="Custom Process Cell Name"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green" @click="addCustomProcessCell">Save</v-btn>
                    <v-btn color="red" @click="closeCustomPcModal">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            selectedProcessGroup: [],
            newProcessName: "",
            items: [],
            search: "",
            // oneOption: "",
            // optionDescription: "",
            // choices: [],
            type: '',
            // choice: [],
            stepItems: ['Step 1', 'Step 2'],
            fieldTypes: [{ name: 'String', value: 'string' }, { name: 'Number', value: 'int' }, { name: 'Decimal', value: 'float' }, { name: 'True/False', value: 'bool' }],
            validationGroup: [{ name: 'Greater than or equal', value: 'GTE' }, { name: 'Lesser than or equal', value: 'LTE' }, { name: 'Equal', value: 'EQ' }, { name: 'Not equal', value: 'NEQ' }],
            step: 1,
            activeCustomField: true,
            customFieldName: "",
            snackbar: false,
            text: "",
            timeout: 3000,
            productDnumber: "",
            newProductName: "",
            productItemList: [],
            selectedProduct: null,
            tab: null,
            isLoadingStructure: false,
            showAddCustomFieldModal: false,
            showAddCustomProcessModal:false,
            showCustomFieldOptionsModal: false,
            showCustomFieldRemovalModal: false,
            newCustomFieldName: "",
            selectedCustomFieldType: "",
            selectedCustomField: null,
            newCustomFieldTypeOption: "",
            historicalCustomField: "",
            newPcellName: "",
            selectedPcellBuilding:"",
        };
    },
    async mounted() {
        await this.getData();

    },
    methods: {
        openCustomPcModal(building) {
            this.showAddCustomProcessModal = true;
            this.selectedPcellBuilding = building;
        },
        closeCustomPcModal(){
            this.showAddCustomProcessModal = false;
            this.selectedPcellBuilding = null;
        },
        async addCustomProcessCell(){
            await axios.post('/apiv1/pcnofbs/pcnofbs-add', {name: this.newPcellName, building_id: this.selectedPcellBuilding.id}).then(res => {
                console.log(res);
                this.getData();
                this.showAddCustomProcessModal = false;
                this.newPcellName = "";
            }).catch(err => {
                console.log(err);
            })
        },
        customSubtitle(type) {
            return type == 'string' ? "Text" : type == 'int' ? "Number" : type == 'float' ? "Decimal" : type == "bool" ? "True/False" : 'undefined'
        },
        async productList() {
            await axios.get('/apiTEST/logbook/list-product').then(res => {
                console.log(res.data);
                this.productItemList = res.data;
            }).catch(err => {
                console.log(err);

            })
        },
        /**
         * Creates a new product by sending a POST request to the server.
         * 
         * @param {string} productName - The name of the new product.
         * @param {string} productDnumber - The D-number of the new product.
         * @param {Object} isActive - A reactive reference to the active state.
         * 
         * @returns {void}
         * 
         * @description
         * This method sends a POST request to the '/apiTEST/logbook/create-product' endpoint with the product name and D-number.
         * On success, it logs the response, sets the isActive reference to false, displays a snackbar with a success message,
         * refreshes the product list, and clears the input fields for product name and D-number.
         * On failure, it logs the error.
         */
        createNewProduct(productName, productDnumber, isActive) {
            axios.post('/apiTEST/logbook/create-product', { name: productName, dnumber: productDnumber }).then(res => {
                console.log(res);
                isActive.value = false;
                this.snackbar = true;
                this.text = "New product has beed created."
                this.productList();
                this.productDnumber = '';
                this.newProductName = '';
            }).catch(err => {
                console.log(err);

            })
        },
        /**
         * Adds a new line to the logbook by sending a POST request to the server.
         *
         * @param {string} newName - The name of the new line.
         * @param {Object} product - The product associated with the new line.
         * @param {Object} processCell - The process cell associated with the new line.
         * @param {Object} isActive - A reactive reference to the active state, which will be set to false upon successful addition.
         *
         * @returns {void}
         */
        addLine(newName, product, processCell, isActive) {
            axios.post('/apiTEST/logbook/create-line', { name: newName, process_cell: processCell.id, product: product }).then(res => {
                console.log(res);
                isActive.value = false;
                processCell.lines.push(res.data);

            }).catch(err => {
                console.log(err);

            })
        },
        createCustomField(name, type, active, pc, isActive) {
            axios.post('/apiv1/pcf/pcf-add', {
                name: name,
                data_type: type,
                global_type: true,
                active: active,
                global_process_cell: pc
            }).then(res => {
                console.log(res);
                isActive.value = false;
                this.getData();

            }).catch(err => {
                console.log(err);

            })

        },
        /**
         * Fetches data from the API endpoint "apiTEST/get_tree" and updates the component state.
         * 
         * This method sets the `isLoadingStructure` flag to true before making an asynchronous
         * GET request to the specified API endpoint. Upon receiving a successful response, it
         * logs the response, updates the `items` property with the received data, calls the
         * `productList` method, and sets the `isLoadingStructure` flag to false.
         * 
         * In case of an error during the request, it logs the error and sets the 
         * `isLoadingStructure` flag to false.
         * 
         * @returns {Promise<void>} A promise that resolves when the data fetching and state updates are complete.
         */
        async getData() {
            this.isLoadingStructure = true;
            await axios.get("apiTEST/get_tree").then(res => {
                console.log(res)
                this.items = res.data;
                this.productList();
                this.isLoadingStructure = false;

            }).catch(err => {
                console.log(err);
                this.isLoadingStructure = false;
            });
            this.isLoadingStructure = false;

        },
        nextStep() {
            if (this.step < 3) {
                this.step++;
            }
        },
        prevStep() {
            if (this.step > 1) {
                this.step--;
            }
        },
        cancelStepper(isActive) {
            isActive.value = false;
            this.choices = [];
            this.step = 1;
            this.oneOption = "";
            this.optionDescription = "";
            this.type = '';
            this.choice = [];
        },
        zeroChoices() { this.choices = [] },
        openAddCustomFieldModal() {
            this.showAddCustomFieldModal = true;
        },
        showSnackbar(text, success) {
            this.text = text;
            this.snackbar = true;
            this.timeout = 3000;
            if (success) {
                this.snackbar = true;
                this.timeout = 3000;
            } else {
                this.snackbar = true;
                this.timeout = 3000;
            }
        },
        closeCustomFieldModal(save) {
            if (save) {
                axios
                    .patch(`apiv1/pcf/${this.selectedCustomField.id}/pcf-update`, { ...this.selectedCustomField, id: undefined })
                    .then(() => {
                        this.showSnackbar("Option added successfully", "success");
                        this.showCustomFieldOptionsModal = false;
                    })
                    .catch((error) => {
                        console.error("Error adding option:", error);
                        this.showSnackbar("Error adding option", "error");
                    });
                if (this.selectedCustomField.data_type !== "choices") {
                    this.selectedCustomField.options = [];
                }
            } else {
                for (const key in this.historicalCustomField) {
                    this.selectedCustomField[key] = this.historicalCustomField[key];
                }
                this.showCustomFieldOptionsModal = false;
            }
        },
        addCustomField() {
            if (!this.newCustomFieldName || !this.selectedCustomFieldType) {
                this.showSnackbar("Please fill in all fields", "error");
                return;
            }
            axios
                .post("apiv1/pcf/pcf-add-demo", {
                    is_global: false,
                    process_cell: null,
                    name: this.newCustomFieldName,
                    logbook: this.logbook.id,
                    line: this.currentLineId,
                    type: this.selectedCustomFieldType,
                })
                .then((response) => {
                    const line = this.logbook.lines.find((l) => l.id === this.currentLineId);
                    if (line) {
                        line.combined_custom_fields.push(response.data);
                    }
                    this.showAddCustomFieldModal = false;
                    this.showSnackbar("Custom field added successfully", "success");
                })
                .catch((error) => {
                    console.error("Error adding custom field:", error);
                    this.showSnackbar("Error adding custom field", "error");
                });
        },
        openCustomFieldOptionsModal(customField) {
            this.selectedCustomField = customField;
            this.historicalCustomField = { ...customField };
            this.showCustomFieldOptionsModal = true;
        },
        removeCustomField() {
            axios
                .delete(`apiv1/pcf/${this.selectedCustomField.id}/pcf-delete`, {})
                .then(() => {
                    this.logbook.lines.forEach((line) => {
                        line.combined_custom_fields = line.combined_custom_fields.filter(
                            (cf) => cf.id !== this.selectedCustomField.id
                        );
                    });
                    this.showSnackbar("Custom Field removed successfully", "success");
                    this.showCustomFieldRemovalModal = false;
                })
                .catch((error) => {
                    console.error("Error removing custom field:", error);
                    this.showSnackbar("Error removing custom field", "error");
                });
        },
        addCustomFieldTypeOption() {
            if (!this.newCustomFieldTypeOption) {
                this.showSnackbar("Please fill in all fields", "error");
                return;
            }
            let boi = { value: this.newCustomFieldTypeOption, loading: true, id: "TEMP" };
            this.selectedCustomField.options.push(boi);

            axios
                .post("apiv1/pcf/pcf-add-option", {
                    pcf: this.selectedCustomField.id,
                    option: this.newCustomFieldTypeOption,
                })
                .then((response) => {
                    this.showSnackbar("Option added successfully", "success");
                    this.selectedCustomField.options.find((option) => option.id === "TEMP").loading = false;
                    this.selectedCustomField.options.find((option) => option.id === "TEMP").id = response.data.id;
                    this.newCustomFieldTypeOption = "";
                })
                .catch((error) => {
                    console.error("Error adding option:", error);
                    this.selectedCustomField.options = this.selectedCustomField.options.filter((option) => option.id !== boi.id);
                    this.showSnackbar("Error adding option", "error");
                });
        },
        openCustomFieldRemovalModal(customField) {
            this.selectedCustomField = customField;
            this.showCustomFieldRemovalModal = true;
        },
    }
};
</script>

<style scoped>
.subitem-selected {
    background-color: rgba(60, 109, 114, 0.2);
}

.buildingRow:hover {
    background-color: rgba(23, 67, 53, 0.05);
}

.v-expansion-panel-title> {
    background-color: blueviolet !important;
}

.v-expansion-panel--active>.v-expansion-panel-title {
    background-color: #eee !important;
}

.v-list-group--open.building {
    background-color: #eee !important;
}

.v-list-group--open.processCellGroup {
    background-color: #e6e6e6 !important;
}

.v-list-group--open.processCell {
    background-color: #d9d9d9 !important;
}
.v-snackbar__content{
    text-align: center!important;
}
.custom-field-options-row-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 2px;
}
</style>